/* eslint-disable react/require-default-props */
import React, { PropsWithChildren, useReducer } from "react";

interface DetailRow {
  title: string;
  value: string;
}

interface AccordionProps {
  title?: string;
  details?: DetailRow[];
  className?: string;
}
export const Accordion = (props: PropsWithChildren<AccordionProps>) => {
  const { children, title, className, details = [] } = props;
  const [isOpen, toggleIsOpen] = useReducer((isOpenNow) => !isOpenNow, false);

  return (
    <div className={className}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        onClick={toggleIsOpen}
        style={{ borderRadius: 10 }}
        className={`cursor-pointer w-full px-6 py-4 flex items-center bg-white ${
          isOpen ? "border-2 border-success-600" : "border border-neutral-400 hover:border-neutral-600"
        }`}
      >
        <div className="w-full">{children}</div>
        <i
          className={`fas text-black ml-6 ${
            isOpen ? "fa-chevron-up" : "fa-chevron-down"
          }`}
        />
      </div>
      {isOpen && (
        <div
          className="border border-neutral-400 p-8 mt-4 bg-white"
          style={{ borderRadius: 10 }}
        >
          <p className="text-lg font-bold mb-2.5">{title}</p>
          {details.map((detail) => (
            <div
              key={detail.title}
              className="flex justify-between border-b border-b-neutral-300  py-4"
            >
              <p>{detail.title}</p>
              <p>{detail.value}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
